import React, { useEffect, useState } from 'react';
import useWebSocket, { ReadyState } from 'react-use-websocket';
import { useSearchParams } from 'react-router-dom'
import SourceText from './SourceText';
import CommentaryComponent from './CommentaryComponent';
import Header from './Header';
import axios from 'axios';
import './GemaraApp.css';

const WS_URL = `${import.meta.env.VITE_API_WS_URL}/addComment`;

const updateSourceTextForSession = async (sessionId, sourceText) => {
  await axios.put(`${import.meta.env.VITE_API_HTTP_URL}/session/${sessionId}`, { SourceTextName: sourceText });
}

const GemaraApp = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [sourceText, setSourceText] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [sessionId, setSessionId] = useState(searchParams.get('sessionId'));
  const [error, setError] = useState(false);
  const [selectedVerse, setSelectedVerse] = useState(null);
  const [commentaryData, setCommentaryData] = useState({
    comments: []
  });

  const sessionWSUrl = WS_URL + (sessionId ? ('?sessionId=' + sessionId) : '');

  const { lastMessage, sendMessage, readyState } = useWebSocket(sessionWSUrl);


  const addCommentToList = (comment) => {
    setCommentaryData(prev => ({
      comments: [...prev.comments, comment]
    }));
  }

  const handleButtonClick = () => {
    updateSourceTextForSession(sessionId, inputValue);
    setSourceText(inputValue);
  };

  const addComment = (title, commentary) => {
    addCommentToList({ title, commentary });
    sendMessage(JSON.stringify({ title, commentary }));
  };

  useEffect(() => {
    if (lastMessage !== null) {
      const message = JSON.parse(lastMessage.data);
      if (message.sessionId) {
        // New session created by server — store the assigned session ID
        setSessionId(message.sessionId.toString());
        setSearchParams({ sessionId: message.sessionId });
      } else if (message.SourceTextName) {
        // Existing session — restore source text and session ID
        setSourceText(message.SourceTextName);
        setInputValue(message.SourceTextName);
        setSearchParams({ sessionId: message.Id });
      } else if (message.title) {
        addCommentToList(message);
      }
    }
  }, [lastMessage]);

  useEffect(() => {
      if(selectedVerse != null) {
        // Load existing comments for this session
        axios
          .get(`${import.meta.env.VITE_API_HTTP_URL}/session/${sessionId}/comments`)
          .then(res => setCommentaryData({ comments: res.data }))
          .catch((error) => { console.log(error); });
      }
  }, [selectedVerse]);

  return (
    <div className="gemara-app">
      <Header connectionStatus={readyState} />
      <div className="source-text-controls">
        <input
          type="text"
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
          className="source-text-input"
        />
        <button onClick={handleButtonClick} className="source-text-button">
          Set Source Text
        </button>
      </div>
      {error && <p className="error-message">Error fetching text from Sefaria. Please double check your spelling</p>}
      {sourceText && (
        <div className="gemara-content">
          <SourceText
            sourceText={sourceText}
            setError={setError}
            selectedVerse={selectedVerse}
            setSelectedVerse={setSelectedVerse}
          />
          {selectedVerse && (
            <CommentaryComponent
              commentaryData={commentaryData}
              addComment={addComment}
              sourceText={sourceText}
              selectedVerse={selectedVerse}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default GemaraApp;
